import apiClient from '@/services/axios'

export async function post(dto) {
  var response = await apiClient.post(process.env.VUE_APP_CRM_API_BASE_URL + '/DynamicForms/Export', dto)
  if (response) {
    return response.data
  }

  throw new Error('Unable to preview dynamic form');
}